import React from 'react';
import styled from 'styled-components';
import { graphql, useStaticQuery } from 'gatsby';
import { useSelector } from 'react-redux';
import Img from 'gatsby-image';
import { theme } from '@style';
import { FeedItem as FeedItemType } from '@types';
import { menus } from '@const';

type FeedProps = {
  feedView: string;
};

const Container = styled.div`
  padding: 40px 0;
`;

const FeedItem = styled.div`
  padding-bottom: 32px;
`;

const Author = styled.div`
  display: flex;
  align-items: center;
  padding: 14px 0;
`;
const Picture = styled(Img)`
  border-radius: 50%;
  width: 32px;
`;

const Action = styled.p`
  color: ${theme.palette.gray};
  display: inline-block;
  padding-left: 8px;
  > span {
    color: ${props => props.theme.palette.actionText};
    font-weight: ${theme.fontBold700};
  }
`;

const Card = styled.div<FeedProps>`
  background-color: ${props => props.theme.palette.cardColor};
  box-sizing: border-box;
  padding: 24px;
  color: ${props => props.theme.palette.cardText};
  font-size: ${theme.fontSizes.md};
  max-width: 800px;
  border-radius: 4px;
  box-shadow: 0 0 20px rgba(0, 0, 0, 0.1);

  > div {
    display: ${props => props.feedView === menus.THICK_MENU && 'none'};
  }
`;
const Title = styled.h1`
  font-weight: ${theme.fontBold700};
  font-size: ${theme.fontSizes.xl};
  padding-bottom: 8px;
  text-transform: capitalize;
  cursor: pointer;
`;
const ExternalLink = styled.div`
  color: ${theme.palette.gray};
`;
const Body = styled.div`
  padding: 8px 0;
  color: ${props => props.theme.palette.bodyText};
`;
const Footer = styled.div`
  display: flex;
  flex-wrap: wrap;
  padding-top: 12px;
  color: ${props => props.theme.palette.footerText};
`;
const Tag = styled.div`
  padding: 4px 8px;
  border: 1px solid ${theme.palette.gray};
  border-radius: 4px;
  margin: 0 8px 8px 0;
`;

export const Feed = () => {
  const data = useStaticQuery(graphql`
    query {
      profileImage: file(relativePath: { eq: "profile.jpeg" }) {
        childImageSharp {
          fluid(maxWidth: 300) {
            ...GatsbyImageSharpFluid
          }
        }
      }
    }
  `);

  const feed: Array<FeedItemType> = useSelector(state => state.app.feedItems);
  const feedView: string = useSelector(state => state.app.feedView);

  return (
    <Container>
      {feed.map((item, i) => (
        <FeedItem key={i}>
          <Author>
            <Picture fluid={data.profileImage.childImageSharp.fluid} />
            <Action>
              <span>{item.author}</span> on the project -{' '}
              <span>{item.date}</span>
            </Action>
          </Author>
          <Card feedView={feedView}>
            <Title>{item.title}</Title>
            <ExternalLink>{item.externalLink}</ExternalLink>
            <Body>{item.text}</Body>
            <Footer>
              {item.categories.map((category, i) => (
                <Tag key={i}>{category}</Tag>
              ))}
            </Footer>
          </Card>
        </FeedItem>
      ))}
    </Container>
  );
};
